// Mobile bottom tab bar (R-147 — the Sentinel Mobile Agent shell nav). A fixed
// row of 3–5 primary destinations rendered as real links (`<a href>` so the
// app's LocationProvider intercepts navigation); the active item gets the
// sidebar's soft-bg highlight, and an item can carry a small count badge
// (e.g. the offline-queue depth on Profile).
import { type ComponentChildren } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './bottom-nav.styles';
export interface BottomNavItem {
  key: string;
  label: string;
  icon: ComponentChildren;
  href: string;
  /** Small count badge on the item's icon; omitted/0 renders nothing. */
  badge?: number;
}
interface BottomNavProps {
  items: BottomNavItem[];
  /** The active item's `key` (prefix-matching is the caller's business). */
  activeKey: string;
  /** Accessible name for the landmark (i18n'd by the caller). */
  label: string;
}
export function BottomNav({
  items,
  activeKey,
  label
}: BottomNavProps) {
  return <nav aria-label={label} {...stylex.props(styles.nav)}>
      {items.map(it => {
      const active = it.key === activeKey;
      return <a key={it.key} href={it.href} aria-current={active ? 'page' : undefined} {...stylex.props(styles.item, active && styles.itemActive)}>
            <span {...stylex.props(styles.icon)} aria-hidden="true">
              {it.icon}
            </span>
            {it.label}
            {it.badge != null && it.badge > 0 && <span {...stylex.props(styles.badge)}>{it.badge}</span>}
          </a>;
    })}
    </nav>;
}